import { ElementType } from 'domelementtype';
import { processTextNode } from './elementTypes/ProcessTextNode.js';
import { processTagNode } from './elementTypes/ProcessTagNode.js';
import { processStyleNode } from './elementTypes/ProcessStyleNode.js';
export function convertNodeToReactElement(node, index, transform) {
    switch (node.type) {
        case ElementType.Text:
            return processTextNode(node);
        case ElementType.Tag:
            return processTagNode(node, index, transform);
        case ElementType.Style:
            return processStyleNode(node, index);
        default:
            return null;
    }
}
//# sourceMappingURL=convertNodeToReactElement.js.map